import { FC } from 'react';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectFilteredQuizzes } from 'store/quiz/quizzesSelectors';
// Componenr
import { Loader, Message } from 'components/Utilities';
// 
import QuizzesListItem from './QuizzesListItem';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  sortedQuizzes: IQuiz[];
  onRequestSort: (key:string) => void;
  getClassNamesFor: (key:string) => void;
}

const QuizzesList:FC<Props> = ({
  // Porps
  sortedQuizzes, onRequestSort, getClassNamesFor
}) => {
  const { t } = useTranslation();
  // State
  const quizzes:IQuiz[] | null = useAppSelector(selectFilteredQuizzes);

  if ( !quizzes ) return <Loader />;
  if ( !quizzes.length ) return <Message text={t('pages.quizzes.noData')} />;
  return (
    <table className="responsive-table">
      <thead>
        <tr>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('quizName')}`}
            onClick={() => onRequestSort('quizName')}
          >{t('labels.name')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('quizTypeLabel')}`}
            onClick={() => onRequestSort('quizTypeLabel')}
          >{t('labels.type')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('category')}`}
            onClick={() => onRequestSort('category')}
          >{t('labels.category')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('createdByName')}`}
            onClick={() => onRequestSort('createdByName')}
          >{t('labels.createdBy')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('createdAt')}`}
            onClick={() => onRequestSort('createdAt')}
          >{t('labels.dateCreated')}</th>
          <th
            className="text-right"
          >{t('labels.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {sortedQuizzes.map((quiz:IQuiz) => (
          <QuizzesListItem
            key={`group-item-${quiz._id}`}
            quiz={quiz}
          />
        ))}
      </tbody>
    </table>
  )
}

export default QuizzesList;
